import { ENDPOINTS } from '@/constants/api'
import type { RequestBodyOf, ResponseData } from '@/types/api'
import { apiSlice } from './base'

type LoginBody = RequestBodyOf<'/api/v1/auth/login', 'post'>
type LoginData = ResponseData<'/api/v1/auth/login', 'post'>
type RefreshData = ResponseData<'/api/v1/auth/refresh', 'post'>
type RefreshBody = RequestBodyOf<'/api/v1/auth/refresh', 'post'>
type LogoutBody = RequestBodyOf<'/api/v1/auth/logout', 'post'>
type ForgotPasswordBody = RequestBodyOf<'/api/v1/auth/forgot-password', 'post'>
type ResetPasswordBody = RequestBodyOf<'/api/v1/auth/reset-password', 'post'>

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginData, LoginBody>({
      query: (body) => ({ url: ENDPOINTS.AUTH.LOGIN, method: 'POST', body }),
      transformResponse: (response: { data: LoginData }) => response.data,
    }),
    refresh: builder.mutation<RefreshData, RefreshBody>({
      query: (body) => ({ url: ENDPOINTS.AUTH.REFRESH, method: 'POST', body }),
      transformResponse: (response: { data: RefreshData }) => response.data,
    }),
    logout: builder.mutation<void, LogoutBody>({
      query: (body) => ({ url: ENDPOINTS.AUTH.LOGOUT, method: 'POST', body }),
    }),
    forgotPassword: builder.mutation<void, ForgotPasswordBody>({
      query: (body) => ({ url: ENDPOINTS.AUTH.FORGOT_PASSWORD, method: 'POST', body }),
    }),
    resetPassword: builder.mutation<void, ResetPasswordBody>({
      query: (body) => ({ url: ENDPOINTS.AUTH.RESET_PASSWORD, method: 'POST', body }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useLoginMutation,
  useRefreshMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = authApi
